<template>
  <span @click.prevent.stop="show.full = true" v-if="!show.full"
    >{{ short[0] }}<a>....</a>{{ short[1] }}</span
  >
  <span v-else>{{ str }}</span>
</template>
<script>
export default {
  name: "short",
  props: ["str", "len"],
  data() {
    return {
      show: {full: false},
    };
  },
  computed: {
    short() {
      let shortstart = this.str.slice(0, this.len || 9);
      let shortend = this.str.slice(this.str.length - (this.len && this.len / 8) || 6, this.str.length);
      return [shortstart, shortend];
    },
  },
};
</script>